import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../../config/NaeSSchema";

class TruckFuelTankModel extends Model {
  static reducer(action, TruckFuelTankModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.TruckFuelTank.schema:
        action.payload.forEach((payload) => {
          const dbData = TruckFuelTankModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          TruckFuelTankModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
TruckFuelTankModel.modelName = "TruckFuelTankModel";

TruckFuelTankModel.fields = {
  id: attr(),
};

export default TruckFuelTankModel;